import React from 'react';
import Button from '../button/Button';

const FantasyFootball = () => {
const cardData = [
  {
    title: 'Rookie Fantasy Football League',
    description:
      'New members who MINT 4 new MetaFans NFTs or those with fewer than five weekly sports bets can join our 20-team Rookie Fantasy Football League. Compete for weekly prizes awarded to the top 2 scorers each week, plus a **TBD** prize pool shared by the top five teams at the end of the season and playoffs.',
    emoji: '🏈',
  },
  {
    title: 'Pro Fantasy Football League',
    description:
      'For existing members owning between 50 and 99 MetaFans NFTs, join our 20-team Pro Fantasy Football League. Enjoy weekly prizes for the top 2 scorers each week and a **TBD** prize pool shared by the top five teams at the end of the season and playoffs.',
    emoji: '🏆',
  },
  {
    title: 'Hall of Fame Fantasy Football League',
    description:
      'Our top holders with 100+ MetaFans NFTs can compete in our exclusive 20-team Hall of Fame Fantasy Football League. Win weekly prizes for the top two highest-scoring teams and share a **TBD** prize pool among the top five teams at the end of the season and playoffs.',
    emoji: '⭐',
  },
  {
    title: 'Biggest Loser Survivor Challenge',
    description:
      'New members or those who MINT one new MetaFan NFT can enter the Biggest Loser Survivor Challenge. Each week, pick a losing team (no team can be picked more than once in a season). The last two survivors share a **TBD** prize pool.',
    emoji: '🧠',
  },
];

  return (
    <div className="bg-gray-900 text-white w-full min-h-screen p-4 sm:p-6 md:p-8 flex flex-col items-center">
      <div className="w-full max-w-7xl">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-8" style={{ color: '#fff' }}>
          🏈 MetaFans Fantasy Football Contests
        </h1>
        <p className="text-center text-base sm:text-lg md:text-xl mb-10 text-gray-200">
          Check out these exciting new fantasy football sports contests for MetaFans members and learn how to qualify!
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          {cardData.map((card, index) => (
            <div
              key={index}
              className="bg-gray-800 p-4 sm:p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex items-center mb-4">
                <span className="text-3xl sm:text-4xl mr-3">{card.emoji}</span>
                <h2 className="text-xl sm:text-2xl font-semibold" style={{ color: '#3872FF' }}>
                  {card.title}
                </h2>
              </div>
              <p className="text-sm sm:text-base text-gray-200">{card.description}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <a
            href="https://discord.gg/metafans"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full sm:w-auto px-6 py-3 text-lg font-bold underline hover:text-blue-400 transition-colors"
            style={{ backgroundColor: '#3872FF', color: '#FFFFFF', display: 'inline-block', borderRadius: '0.375rem' }}
          >
            Join the MetaFans Contests Now!
          </a>
        </div>
      </div>
    </div>
  );
};

export default FantasyFootball;